import { createContext } from 'react';

export type ResourceId = string;

export type UseAuthorization = {
  hasPermission: (
    resourceType: 'organization',
    resourceId: ResourceId | null,
    ...permissions: ['org-invite']
  ) => boolean;
};

export interface LegacyContextProps {
  event?: (actionName: string) => void;
  tagRecording?: (tag: string) => void;
  useAuthorization?: () => UseAuthorization;
}

export const LegacyContext = createContext<LegacyContextProps>({});

export const LegacyProvider = LegacyContext.Provider;
